import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class BreakpointService {
    constructor(private readonly breakpointObserver$: BreakpointObserver) {}

    isMobileView$() {
        return this.breakpointObserver$.observe(["(max-width: 600px)"]).pipe(map((state: BreakpointState) => state.matches));
    }

    isMediumViewport$() {
        return this.breakpointObserver$.observe(["(max-width: 959px)"]).pipe(map((state: BreakpointState) => state.matches));
    }
}
